<template>
  <q-select
    v-bind="$attrs"
    v-model="innerValue"
    :label="label"
    :options="options"
    :error="error"
    :error-message="errorMessage"
    :dense="dense"
    :outlined="outlined"
    :lazy-rules="lazyRules"
    :disable="isDisabled"
  >
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>
    <template v-if="$slots.append" #append>
      <slot name="append" />
    </template>
    <slot />
  </q-select>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: { type: [String, Number, Object, null], default: null },
  label: { type: String, default: '' },
  options: { type: Array, default: () => [] },
  outlined: { type: Boolean, default: true },
  dense: { type: Boolean, default: true },
  lazyRules: { type: Boolean, default: true },
  dependency: {
    type: [String, Object, Number, Array, null],
    default: undefined,
  },
  disable: {
    type: Boolean,
    default: false,
  },
  error: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

const innerValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const isDisabled = computed(() => props.disable || (props.dependency !== undefined && !props.dependency));
</script>
